import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { AccountingReviewItemResource } from "@exonn/js-sdk";
import { getResourceI18nNamespace } from "src/system/getResourceI18nNamespace.ts";

/**
 * Review items: every case exonn could not decide unambiguously (missing account
 * mapping, chart mismatch, unclear open-item migration, …). They are created by
 * the backend only and closed with a documented decision — never edited or deleted.
 */
export const module: ModuleOptions<AccountingReviewItemResource> = {
  resource: ResourceEnum.AccountingReviewItem,
  bigIcon: <span className={"icon-20-decision"} />,
  smallIcon: <span className={"icon-15-decision"} />,
  disableCreate: true,
  disableDelete: true,
  tabs: {
    edit: {
      getTitle: (resource, t) =>
        t(`field.type.options.${resource.type}`, {
          ns: getResourceI18nNamespace(ResourceEnum.AccountingReviewItem),
          defaultValue: resource.type,
        }),
    },
  },
};
